import Vuex from 'vuex'

import ersStore from '@/apps/ERS/store'
import auth, { Actions as authActions, Mutations as authMutations } from './Auth/index.js'
import log, { Actions as logActions, Mutations as logMutations } from './Log/index.js'

// TODO: use enums for mutation and action names everywhere
export const Mutations = {
  SET_CONFIG: 'μ: Set config',
  SET_UNREAD_MESSAGES: 'μ: Set unread messages',
  SET_REQUEST_REF: 'μ: Set request ref',
  RESET_REQUEST_REF: 'μ: Reset request ref',
  ...authMutations,
  ...logMutations,
}

export const Actions = {
  ...authActions,
  ...logActions,
}

function getDefaultState() {
  return {
    unread_messages: null,
    requestRef: null,
    config: null,
  }
}

const state = getDefaultState()

export default new Vuex.Store({
  state,
  getters: {
    hasUnreadMessages(state) {
      return !!state.unread_messages
    },
    getRequestRef(state) {
      return state.requestRef
    },
    getConfig(state) {
      return state.config
    },
  },
  mutations: {
    SET_UNREAD_MESSAGES(state, unread_messages) {
      state.unread_messages = unread_messages
    },
    SET_REQUEST_REF(state, requestRef) {
      state.requestRef = requestRef
    },
    RESET_REQUEST_REF(state) {
      state.requestRef = null
    },
    [Mutations.SET_CONFIG](state, config) {
      state.config = config
    },
  },
  modules: {
    auth,
    ersStore,
    log,
  },
})
